
const SearchRequest = {
  "nationality": "string",
  "checkIn": "string",
  "checkOut": "string",
  "cityCode": 0,
  "occupancies": [
    {
      "adultCountInRoom": 0,
      "childCountInRoom": 0,
      "childAgesInRoom": [
        0
      ]
    }
  ]
  };
 

  export default SearchRequest;
  